module.exports = __webpack_public_path__ + "img/y_p3_ditu.7e9d7a3f.svg";